// extracted by mini-css-extract-plugin
export var actionButton = "_mb-0";
export var actionMenuContainer = "_mb-i";
export var bubble = "_mb-2";
export var bubbleActionMenu = "_mb-j";
export var bubbleContext = "_mb-6";
export var bubbleItems = "_mb-7";
export var customer = "_mb-3";
export var divider = "_mb-8";
export var fileList = "_mb-9";
export var hiddenComment = "_mb-o";
export var infoAbove = "_mb-a";
export var internal = "_mb-4";
export var lightActionButton = "_mb-1";
export var link = "_mb-b";
export var merchant = "_mb-5";
export var message = "_mb-c";
export var profilePicture = "_mb-e";
export var quillToolbarContainer = "_mb-f";
export var senderDate = "_mb-g";
export var senderDateCustomer = "_mb-h";
export var senderName = "_mb-d";
export var time = "_mb-k";
export var uploadedImage = "_mb-l";
export var username = "_mb-m";
export var xsmall = "_mb-n";